<template>
  <section class="bloc-slider">
    <div class="bloc-slider__wrapper swiper-container scroll-step js-scroll-show" ref="slider">
      <ul class="bloc-slider__slider swiper-wrapper">
        <li v-for="(item, i) in content.items" :key="i" class="item swiper-slide">
          <img class="item__img" :src="require(`@/${item.img}`)">
        </li>
      </ul>

      <!-- <div class="swiper-pagination-container">
        <div class="swiper-pagination" ref="pagination"></div>
      </div> -->

      <div class="slider__nav swiper-nav">
        <div class="navigation-left prev" ref="navLeft">
            <div class="navigation-icon">
              <img svg-inline class="arrow" src="@/assets/images/icons/arrow.svg" />
            </div>
        </div>

        <div class="navigation-right next" ref="navRight">
            <div class="navigation-icon">
              <img svg-inline class="arrow" src="@/assets/images/icons/arrow.svg" />
            </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Swiper, { Navigation, Pagination }  from 'swiper'
Swiper.use([Navigation, Pagination]);

export default {
  name: 'TextImage',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      slidesPerViewParams: {
        wide: 1,
        desktop: 1,
        tablet: 1,
        mobile: 1
      },
      loop: true,
      hasDots: true
    }
  },
  mounted () {
    this.initParams()
  },
  methods: {
    initParams () {
      const navigation = this.slidesPerViewParams.noNavArrow ?
        {} :
        {
          nextEl: this.$refs.navRight,
          prevEl: this.$refs.navLeft
        }

      // const pagination = this.hasDots ?
      //   {
      //     el: this.$refs.pagination,
      //     type: 'bullets',
      //     clickable: true,
      //   } : {}

      this.slider = new Swiper(this.$refs.slider, {
        slidesPerView: this.slidesPerViewParams.mobile || 1,
        centeredSlides: this.slidesPerViewParams.centerMode,
        spaceBetween: 0,
        grabCursor: true,
        speed: 500,
        loopedSlides: this.loop ?  2 : null,
        loop: this.loop,
        initialSlide: this.loop ? 1 : 0,
        navigation: navigation,
        // pagination: pagination,
        breakpoints: {
          1000: {
            slidesPerView: this.slidesPerViewParams.desktop || 1,
          },
          1500: {
            slidesPerView: this.slidesPerViewParams.wide || this.slidesPerViewParams.desktop || 1,
          },
        },
      });

      this.slides = [...this.$refs.slider.querySelectorAll('.swiper-slide')]
    },
    goNext () {
      this.slider.slideNext()
    }
  }
}
</script>

<style lang="scss">
  .bloc-slider {
    width: 100vw;
    background: $th-cherry;
    padding: rem(45px) 0;
    overflow: hidden;
    position: relative;

    &__wrapper {
      width: grid_m(5, 4);
      margin: 0 auto;
      position: relative;

      @include media($from: small) {
        width: grid(6, 5);
      }
    }

    &__slider {
      display: flex;
      flex-wrap: nowrap;
    }

    .item {
      width: 100%;
      flex-shrink: 0;
      height: grid_m(3.5, 2);
      position: relative;

      @include media($from: small) {
        height: grid(4, 3);
      }
    }

    .item__img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .slider__nav {
      position: absolute;
      width: grid_m(4.5, 4);
      top: 50%;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
      display: flex;
      justify-content: space-between;
      pointer-events: none;
      padding: 0 10px;

      @include media($from: small) {
        width: grid(11, 10);
        left: 50%;
        transform: translateX(-50%);
      }

      .navigation-right,
      .navigation-left {
        pointer-events: auto;
        transition: opacity 0.3s $quad-ease-out;
        transform: scale(0.8);
        cursor: pointer;

        &.swiper-button-disabled {
          opacity: 0;
        }

        @include media($from: small) {
          transform: none;
        }
      }

      .navigation-left {
        transform: scale(0.8) rotate(-180deg);

        @include media($from: small) {
          transform: rotate(-180deg);
        }
      }
    }

    // .swiper-pagination-container {
    //   position: absolute;
    //   bottom: -40px;
    //   left: 50%;
    //   transform: translateX(-50%);

    //   .swiper-pagination {
    //     position: relative !important;
    //     bottom: initial !important;
    //     display: flex !important;

    //     .swiper-pagination-bullet {
    //       width: 7px;
    //       height: 7px;
    //       display: flex;
    //       position: relative;
    //       cursor: pointer;
    //       margin: 0 5px;
    //       opacity: 1;
    //       border: 1px solid $th-white;
    //       background: none;
    //       transition: background 0.3s $quad-ease-out, border 0.3s $quad-ease-out;

    //       @include media($from: small) {
    //         width: 10px;
    //         height: 10px;
    //       }

    //       &-active {
    //         background: $th-yellow;
    //         border: 1px solid $th-yellow;
    //       }
    //     }
    //   }
    // }
  }
</style>
